import { forwardRef } from 'react';
import type { AppIconProps } from './app-icon';
import {
  mingcuteLineIconAssetBasePath,
  mingcuteLineIconSpritePath,
} from './mingcute-line-icon-assets.generated';
import type { MingcuteLineIconKey } from './mingcute-line-icon-catalog.generated';

export type MingcuteLineIconAssetMode = 'individual' | 'sprite';

export function getMingcuteLineIconAssetHref(
  iconKey: MingcuteLineIconKey,
  mode: MingcuteLineIconAssetMode
) {
  const fragment = `#app-icon-${iconKey}`;
  return mode === 'sprite'
    ? `${mingcuteLineIconSpritePath}${fragment}`
    : `${mingcuteLineIconAssetBasePath}/icons/${iconKey}.svg${fragment}`;
}

export const MingcuteLineAssetIcon = forwardRef<
  SVGSVGElement,
  AppIconProps & {
    assetMode?: MingcuteLineIconAssetMode;
    iconKey: MingcuteLineIconKey;
  }
>(
  (
    { assetMode = 'individual', color, iconKey, size = 24, style, ...props },
    ref
  ) => (
    <svg
      height={size}
      ref={ref}
      style={color === undefined ? style : { color, ...style }}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <use href={getMingcuteLineIconAssetHref(iconKey, assetMode)} />
    </svg>
  )
);

MingcuteLineAssetIcon.displayName = 'MingcuteLineAssetIcon';
